import { mobileRatio, tabletRatio, theme } from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const productDropdownStyles = {
  productDropdown: {
    position: 'relative',
    '& .product-btn': {
      '& .MuiButton-startIcon': {
        width: getResponsiveSize(22), // 24px
        minWidth: '22px',
        fill: 'none',
        '& path': {
          fill: theme.palette.neutral.white,
        },
      },
      '& .MuiButton-endIcon': {
        ...theme.palette.propVars.easeInOutTransition,
        '& svg': {
          fontSize: getResponsiveSize(28), // 28px
        },
      },
    },
    '& .dropdown-popper': {
      width: '100%',
      zIndex: 1,
      '& .MuiPaper-root ': {
        borderRadius: getResponsiveSize(12), // 12px
        border: `1px solid ${theme.palette.myPrimary.lightBlue100}`,
        '& .MuiMenuItem-root': {
          color: theme.palette.neutral.grey70,
          fontSize: getResponsiveSize(16), // 16px
          borderRadius: getResponsiveSize(12), // 12px
          mx: getResponsiveSize(12), // 12px,
          textTransform: 'capitalize',
          minHeight: getResponsiveSize(48), // 48px,
          padding: `${getResponsiveSize(6)} ${getResponsiveSize(16)}`, // 6px 16px
          backgroundImage: 'none',
          justifyContent: 'flex-start',
          boxShadow: 'none',
          ...theme.palette.propVars.regularFontWeight,
          ...theme.palette.propVars.easeInOutTransition,
          '&[aria-selected="true"]': {
            background: 'transparent',
          },
          '&:hover, &.Mui-focused': {
            background: theme.palette.myPrimary.lightBlue20,
            boxShadow: 'none',
          },
        },
      },
    },
    '&.open .MuiButton-endIcon': {
      transform: 'rotate(180deg)',
    },
    // Tablet screen
    [theme.breakpoints.media.tablet]: {
      '& .dropdown-popper .MuiPaper-root': {
        '& .MuiMenuItem-root': {
          fontSize: getResponsiveSize(13, tabletRatio), // 13px
          padding: `${getResponsiveSize(4, mobileRatio)} ${getResponsiveSize(
            12,
            tabletRatio,
          )}`, // 4px 12px
        },
      },
    },
    // Table simple responsive screen
    [theme.breakpoints.media.tableResponsive]: {
      '& .dropdown-popper .MuiPaper-root': {
        '& .MuiMenuItem-root': {
          fontSize: getResponsiveSize(13, mobileRatio), // 13px
          padding: `${getResponsiveSize(4, mobileRatio)} ${getResponsiveSize(
            12,
            mobileRatio,
          )}`, // 4px 12px
        },
      },
    },
  },
};
